import { render, staticRenderFns } from "./ProductSubgroup.vue?vue&type=template&id=3f44c2b7&"
import script from "./ProductSubgroup.vue?vue&type=script&lang=js&"
export * from "./ProductSubgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f44c2b7')) {
      api.createRecord('3f44c2b7', component.options)
    } else {
      api.reload('3f44c2b7', component.options)
    }
    module.hot.accept("./ProductSubgroup.vue?vue&type=template&id=3f44c2b7&", function () {
      api.rerender('3f44c2b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-subgroup/ProductSubgroup.vue"
export default component.exports